import { createSlice } from "@reduxjs/toolkit";
import { fetchAppliedJobs } from "./actions";

const initialState = {
  appliedJobListData: {},
  appliedJobListDataLoading: false,
  appliedJobListDataError: null,
};
const appliedJobSlice = createSlice({
  name: "appliedjob",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchAppliedJobs.pending, (state) => {
        state.appliedJobListDataLoading = true;
        state.appliedJobListDataError = null;
      })
      .addCase(fetchAppliedJobs.fulfilled, (state, action) => {
        state.appliedJobListDataLoading = false;
        state.appliedJobListData = action.payload;
      })
      .addCase(fetchAppliedJobs.rejected, (state, action) => {
        state.appliedJobListDataLoading = false;
        state.appliedJobListDataError = action.payload;
      });

  },
});
export default appliedJobSlice.reducer;
